import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { multiSignatureComponent } from './multiSignature.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SubHeaderModule } from '../../components/common/sub-header/sub-header.module';
import { DivisionDetailModule } from '../../dossiers/components/divisionDetail.module';
import { TableModule } from 'primeng-lts/table';
import { CheckboxModule } from 'primeng-lts/checkbox';
import { OverlayPanelModule } from 'primeng-lts/overlaypanel';
import { ProgressBarModule } from 'primeng-lts/progressbar';
import { ScrollPanelModule } from 'primeng-lts/scrollpanel';
import { DocumentViewerModule } from '../../documents/documentViewer/documentViewer.module';
@NgModule({
  declarations: [multiSignatureComponent],
  imports: [TranslateModule, CommonModule, FormsModule,
    SubHeaderModule, ScrollPanelModule, CheckboxModule, DivisionDetailModule,
    OverlayPanelModule, TableModule, ProgressBarModule, DocumentViewerModule],
  exports: [multiSignatureComponent]
})
export class MultiSignatureModule { }
